import React, { useEffect, useState } from 'react';
import { Table, Statistic, Tag } from 'antd';
import moment from 'moment';
import { VscEye } from 'react-icons/vsc';
import PlatformIconRender from '../../../Common/PlatformIconRender';
import { Link } from 'react-router-dom';
import CurrencyIcon from '../../../Common/CurrencyIcon';
const CampaignsTableComponent = ({ campObj, companyOverview }) => {
  const [camps, setCamps] = useState({
    pager: {
      page: 1,
      total: 0,
      limit: 10,
    },
    data: [],
  });
  useEffect(() =>{
    setCamps({
      ...camps,
      pager: {
        ...camps.pager,
        page: campObj.page,
        limit: campObj.limit,
        total: campObj.totalDocs,
      },
      data: campObj.campaigns.map((camp)=>{
        return {
          key: camp.id,
          name: camp.name || 'N/A',
          id: camp.id || 'N/A',
          // brand:camp.brandname || 'N/A',
          budget: camp.budget || 'N/A',
          objective: camp.objective || 'N/A',
          startdate: moment(camp.startdate).format('Do MMM YYYY'),
          enddate: moment(camp.enddate).format('Do MMM YYYY'),
          platform: camp.platform || 'N/A',
          status: camp.campaignstatus || 'N/A',
          paymentCompleted: camp.paymentstatus,
        };
      }),
    });
  }, [campObj]);
  // @note: table columns setup
  const columns = [
    {
      title: 'Campaign Name',
      dataIndex: 'name',
      render: (v, other) =>(
        <>
          <p className="m-0"><strong>{v}</strong></p>
          <p className="m-0"
            style={{ fontSize: '0.7rem', color: '#999' }}>{other.id}</p>
        </>
      ),
    },
    {
      with: 100,
      title: 'Budget',
      dataIndex: 'budget',
      render: (v) =>(
        <>
          {CurrencyIcon()}<Statistic className="custom_number_format"
            value={v}
            precision={2}/>
        </>
      ),
    },
    {
      title: 'Objective',
      align: 'center',
      dataIndex: 'objective',
    },
    {
      width: 150,
      title: 'Date(Start-End)',
      dataIndex: 'startdate',
      align: 'center',
      render: (v, other) =>(
        <>
          <div style={{ fontSize: '12px' }}>{v}</div>
          <div className="text-center"
            style={{ fontSize: '12px' }}>To</div>
          <div style={{ fontSize: '12px' }}>{other.enddate}</div>
        </>
      ),
    },
    {
      title: 'Platform',
      dataIndex: 'platform',
      align: 'center',
      render: (v) => <PlatformIconRender platform={v}
        size={24}/>,
    },
    {
      width: 80,
      title: 'Status',
      dataIndex: 'status',
      align: 'center',
      render: (_v) =>{
        switch (_v) {
        case 'review':
          return <Tag color="purple"
            className="m-0">{_v}</Tag>;
        case 'published':
          return <Tag color="lime"
            className="m-0">{_v}</Tag>;
        case 'active':
          return <Tag color="green"
            className="m-0">{_v}</Tag>;
        case 'closed':
          return <Tag color="red"
            className="m-0">{_v}</Tag>;
        case 'rejected':
          return <Tag color="red"
            className="m-0">{_v}</Tag>;
        default:
          return <Tag color="gold"
            className="m-0"
            style={{ maxWidth: 80, white: 'break-all', whiteSpace: 'pre-wrap' }}>{_v}</Tag>;
        }
      },
    },
    {
      width: 100,
      title: 'Payment Status',
      dataIndex: 'paymentCompleted',
      align: 'center',
      render: (v) =>(
        v ? <Tag color="green">Completed</Tag> : <Tag color="gold">Pending</Tag>
      ),
    },
    {
      title: 'Action',
      key: 'download',
      align: 'center',
      width: 80,
      render: (v, other) => {
        if (other.status === 'published') {
          return (<Link to={`/admin/dashboard/campaigns/${other.id}?status=${other.status}&view=creatives`}
            className="common_button py-2"
            title="View Campaign">
            <VscEye/>
          </Link>);
        } else if (other.status === 'active') {
          return (<Link to={`/admin/dashboard/campaigns/${other.id}?status=${other.status}&view=statistics`}
            className="common_button py-2"
            title="View Campaign">
            <VscEye/>
          </Link>);
        } else {
          return (<Link to={`/admin/dashboard/campaigns/${other.id}?status=${other.status}&view=brief`}
            className="common_button py-2"
            title="View Campaign">
            <VscEye/>
          </Link>);
        }
      },
    },
  ];
    // @note: page changing if more than
  const changePage = (page) =>{
    const { pager } = camps;
    companyOverview(page, pager.limit);
  };
  return (
    <div className="common_card p-3 txn_history h-100">
      <div className="row">
        <div className="col-md-12 mt-4">
          <Table
            columns={columns}
            dataSource={camps.data || []}
            pagination={{
              current: camps.pager.page,
              total: camps.pager.total,
              showSizeChanger: false,
              showQuickJumper: true,
              onChange: (v) => changePage(v),
            }}
          />
        </div>
      </div>
    </div>
  );
};
export default CampaignsTableComponent;
